import { DashboardAccess } from './capabilities.constants';

export interface SalesPermissionFlagSource {
  dashboards: DashboardAccess;
  isAgent: boolean;
  isTeamLead: boolean;
  isManager: boolean;
}

export interface SalesPermissionFlags {
  dashboards: DashboardAccess;
  isAgent: boolean;
  isTeamLead: boolean;
  isManager: boolean;
  isAgentL1Pure: boolean;
  isAgentL2Pure: boolean;
  isAgentL3Pure: boolean;
  isTeamLeadL1: boolean;
  isTeamLeadL2: boolean;
  isTeamLeadL3: boolean;
  canActOnL1Lead: boolean;
  canActOnL2Lead: boolean;
  canActOnL3Lead: boolean;
  isAgentL2OrL3Pure: boolean;
  isManagerOrTeamLead: boolean;
  showManagerOrTLBadge: boolean;
  isNonManagerL2Dashboard: boolean;
  searchBySalesAgent : boolean;
  isBusinessValidationAgent: boolean;
  isBusinessValidationTeamLead: boolean;
  canActOnBusinessValidationLead: boolean;
  canSeeNotifications : boolean;
}

export function buildSalesPermissionFlags(source: SalesPermissionFlagSource): SalesPermissionFlags {
  const d = source.dashboards;
  const isAgentL1Pure = source.isAgent && !!d.l1 && !d.l2 && !d.l3;
  const isAgentL2Pure = source.isAgent && !!d.l2 && !d.l1 && !d.l3;
  const isAgentL3Pure = source.isAgent && !!d.l3 && !d.l1 && !d.l2;
  const isTeamLeadL1 = source.isTeamLead && !!d.l1 && !d.l2;
  const isTeamLeadL2 = source.isTeamLead && !!d.l2 && !d.l1;
  const isTeamLeadL3 = source.isTeamLead && !!d.l3 && !d.l1 && !d.l2;
  const searchBySalesAgent = isAgentL1Pure || isAgentL2Pure || isAgentL3Pure || isTeamLeadL1 || isTeamLeadL2 || isTeamLeadL3

  const isBusinessValidationAgent = source.isAgent && !!d.l4 && !d.l1 && !d.l2 && !d.l3;
  const isBusinessValidationTeamLead = source.isTeamLead && !!d.l4 && !d.l1 && !d.l2 && !d.l3;
  return {
    dashboards: d,
    isAgent: source.isAgent,
    isTeamLead: source.isTeamLead,
    isManager: source.isManager,
    isAgentL1Pure,
    isAgentL2Pure,
    isAgentL3Pure,
    isTeamLeadL1,
    isTeamLeadL2,
    isTeamLeadL3,
    canActOnL1Lead: isAgentL1Pure || isTeamLeadL1,
    canActOnL2Lead: isAgentL2Pure || isTeamLeadL2,
    canActOnL3Lead: isAgentL3Pure || isTeamLeadL3,
    isAgentL2OrL3Pure: isAgentL2Pure || isAgentL3Pure,
    isManagerOrTeamLead: source.isManager || source.isTeamLead,
    showManagerOrTLBadge: source.isManager || isTeamLeadL1,
    isNonManagerL2Dashboard: !source.isManager && !!d.l2 && !d.l1,
    searchBySalesAgent ,
    isBusinessValidationAgent,
    isBusinessValidationTeamLead,
    canActOnBusinessValidationLead: isBusinessValidationAgent || isBusinessValidationTeamLead,
    canSeeNotifications : isAgentL1Pure || isAgentL2Pure || isAgentL3Pure || isTeamLeadL1 || isTeamLeadL2 || isTeamLeadL3 || isBusinessValidationAgent || isBusinessValidationTeamLead
  };
}
